import React from "react"
import { Badge, IconButton, Tooltip } from "@material-ui/core"
import { Phone as PhoneIcon } from "@material-ui/icons"

import VoiceCallDialog, { VoiceCallDialogProps } from "@/components/VoiceCall/VoiceCallDialog"
import Notification from "@/components/Notification"

import useSubscriptionLimits from "@/hooks/useSubscriptionLimits"

import AnalyticsService from "@/services/Analytics"

import useStyles from "@/components/VoiceCall/VoiceCallButton/styles"

const SHOW_NEW_BADGE = true

type VoiceCallButtonProps = {
	VoiceCallDialogProps: Omit<VoiceCallDialogProps, "mustBlock" | "isLoading">
	disabled?: boolean
	disabledTooltipText?: string
}

const VoiceCallButton: React.FC<VoiceCallButtonProps> = (props) => {
	const {
		VoiceCallDialogProps,
		disabled,
		disabledTooltipText
	} = props

	const classes = useStyles()

	const { mustBlock, isLoading } = useSubscriptionLimits("quantity", "voice_call_minutes")

	const handleOpen = () => {
		AnalyticsService.capture("voice_call_button_clicked")

		if (VoiceCallDialog.isOpened()) {
			Notification.warning({ message: "Só é possível abrir um discador de ligação de cada vez." })
		} else {
			VoiceCallDialog.open({
				...VoiceCallDialogProps,
				mustBlock,
				isLoading
			})
		}
	}

	const iconButton = (
		<IconButton disabled={disabled} onClick={handleOpen}>
			<PhoneIcon />
		</IconButton>
	)

	return (
		<Tooltip title={disabled ? String(disabledTooltipText) : "Ligar para contato"}>
			<span>
				{SHOW_NEW_BADGE ? (
					<Badge
						badgeContent="Novo"
						classes={{ badge: classes.badge }}
					>
						{iconButton}
					</Badge>
				) : (
					iconButton
				)}
			</span>
		</Tooltip>
	)
}

export default VoiceCallButton
